<template>
  <div>
    <Header2>{{ "Neueste Fotos von Veranstaltungen".toUpperCase() }}</Header2>
    <Carousel>
      <template v-if="loading">
        <GalleryDashboardCardLoader
          class="gallery-dashboard-card"
          v-for="i in 5"
          :key="i"
        />
      </template>
      <template v-else-if="fetchError">
        <div>
          ⚠️ Es gab einen Fehler beim Laden der Fotos von Veranstaltungen.
        </div>
      </template>
      <template v-else-if="eventGalleryItems.length === 0">
        <div>
          Es gibt noch keine Fotos von Veranstaltungen. Teile doch deine Fotos
          zu einer Veranstaltung.
        </div>
      </template>
      <template v-else>
        <GalleryDashboardCard
          class="gallery-dashboard-card"
          v-for="(item, i) in eventGalleryItems"
          :key="item.id"
          :event-gallery="item"
        />
      </template>
    </Carousel>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue"
import Header2 from "app/ui-primitives/header/Header2.vue"
import { eventMediaApi } from "store/api"
import { AscDescOrder } from "suus-api"
import GalleryDashboardCardLoader from "features/gallery/dashboard/GalleryDashboardCardLoader.vue"
import GalleryDashboardCard from "features/gallery/dashboard/GalleryDashboardCard.vue"
import Carousel from "app/ui-primitives/carousel/Carousel.vue"

export default defineComponent({
  name: "GalleryDashboardSection",
  components: {
    Carousel,
    GalleryDashboardCardLoader,
    Header2,
    GalleryDashboardCard,
  },
  setup() {
    const loading = ref(true)
    const fetchError = ref(false)
    const eventGalleryItems = ref([])

    const fetchEventGalleryItems = async () => {
      try {
        const response = await eventMediaApi.getGalleries(
          0,
          5,
          AscDescOrder.Desc,
          4
        )
        eventGalleryItems.value = response.data
        loading.value = false
      } catch (e) {
        console.error("Error fetching event gallery items", e)
        fetchError.value = true
      } finally {
        loading.value = false
      }
    }

    fetchEventGalleryItems()

    return {
      loading,
      fetchError,
      eventGalleryItems,
    }
  },
})
</script>

<style scoped lang="sass">
.gallery-dashboard-card
  flex-shrink: 0
  margin-right: 16px
  &:last-child
    margin-right: 0 !important
</style>
